function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-764.000000, -3028.000000)",
  stroke: "#183E6B",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(120.000000, 245.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 2757.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(626.000000, 27.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.406813953,60.4607907 C0.406813953,67.3533488 7.99611628,69.8074186 13.5765814,69.8074186 C19.1537907,69.8074186 26.7463488,67.3533488 26.7463488,60.4607907 C26.7463488,54.802186 23.7640233,53.333 16.5654186,49.7849767 L12.411,47.7240465 C4.92588372,44.0343953 0.406813953,41.818 0.406813953,34.1212558 C0.406813953,27.3092791 5.08867442,22.5110233 12.6226279,21.5790465"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.746593,9.75482558 C26.746593,2.86145349 19.1572907,0.407383721 13.5768256,0.407383721 C7.99961628,0.407383721 0.40705814,2.86145349 0.40705814,9.75482558 C0.40705814,15.4126163 3.38938372,16.8818023 10.5879884,20.4298256 L14.742407,22.4907558 C22.2275233,26.180407 26.746593,28.3968023 26.746593,36.0935465 C26.746593,42.9055233 22.0647326,47.7037791 14.5307791,48.6357558"
})))))));
var SvgIconParagraph = function SvgIconParagraph(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "72px",
    viewBox: "0 0 29 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconParagraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-paragraph.20b997af.svg";
export { ForwardRef as ReactComponent };